import { createSelector } from 'reselect';

export const getBrowser = state => state.browser;
export const getPersistentSidebar = createSelector(
  getBrowser,
  browser => browser.greaterThan.smallish  
);

export const getIsLandscape = createSelector(
  getBrowser,
  browser => browser.orientation === 'landscape'
);

export const getIsSmallScreen = createSelector(
  getBrowser,
  getIsLandscape,
  (browser, isLandscape) => isLandscape
    ? browser.lessThan.medium
    : browser.lessThan.small
);



// WEBPACK FOOTER //
// ./src/store/browser/selectors.js